import React from 'react';

const TabsContentListLayout = ({ children }) => (
  <div className="ws-ui-tabs__content-list-layout">{children}</div>
);

export default TabsContentListLayout;
